import { DeviceApiError } from '@ghostscreen/player-core';

export function formatPlayerError(error: unknown): string {
  if (error instanceof DeviceApiError) {
    if (error.status === 401 || error.status === 403) {
      return 'This pairing code is invalid or already used.';
    }
    if (error.status === 404) {
      return 'Pairing code not found. Generate a new one in the dashboard.';
    }
    if (error.status >= 500) {
      return 'Server error. Try again in a moment.';
    }
    return error.body.trim() || error.message;
  }
  if (error instanceof Error) return error.message;
  return 'Something went wrong.';
}
